import { ca } from '@cian/analytics';

export const trackImagesFeatureClick = () => {
  ca('event', {
    name: 'oldevent',
    category: 'FeaturesJK',
    action: 'Click',
    label: 'Images',
    pageType: 'Card',
  });
};

export const trackVideosFeatureClick = () => {
  ca('event', {
    name: 'oldevent',
    category: 'FeaturesJK',
    action: 'Click',
    label: 'Videos',
    pageType: 'Card',
  });
};

export const trackReviewsFeatureClick = () => {
  ca('event', {
    name: 'oldevent',
    category: 'FeaturesJK',
    action: 'Click',
    label: 'Reviews',
    pageType: 'Card',
  });
};

export const trackConstructionProgressFeatureClick = () => {
  ca('event', {
    name: 'oldevent',
    category: 'FeaturesJK',
    action: 'Click',
    label: 'BuildingProgress',
    pageType: 'Card',
  });
};
